// playStyle统一格式化
export const formatValues = (value, tacticSeasonList) => {
  const expandedValues = [];

  value.forEach((selectedPath) => {
    if (selectedPath.length === 1) {
      // 如果只选择了父级，找到对应的父级项并添加所有子项
      const parentId = selectedPath[0];
      const parentItem = tacticSeasonList.find((item) => item.id === parentId);
      if (parentItem && parentItem.children) {
        expandedValues.push(...parentItem.children);
      }
    } else if (selectedPath.length === 2) {
      // 如果选择了具体的子项，找到对应的子项
      const [parentId, childId] = selectedPath;
      const parentItem = tacticSeasonList.find((item) => item.id === parentId);
      if (parentItem && parentItem.children) {
        const childItem = parentItem.children.find((child) => child.id === childId);
        if (childItem) {
          expandedValues.push(childItem);
        }
      }
    }
  });

  // 去重（基于 id）
  const uniqueValues = expandedValues.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id));
  return uniqueValues.map((item) => ({ id: item.id, typeName: item.name }));
};

// label统一格式化
export const formatLabelsValues = (value, tacticList) => {
  const leafNodes = extractLeafNodes(value, tacticList);
  return leafNodes.map((item) => ({ id: item.id, typeName: item.name }));
};

const extractLeafNodes = (selectedPaths, dataSource) => {
  const leafNodes = [];

  // 递归函数：从当前节点开始收集所有叶子节点
  const collectLeafNodes = (node) => {
    if (!node.children || node.children.length === 0) {
      // 如果没有子节点，这是一个叶子节点
      leafNodes.push(node);
    } else {
      // 如果有子节点，递归收集所有子节点的叶子节点
      node.children.forEach((child) => collectLeafNodes(child));
    }
  };

  // 根据路径在数据源中查找节点的函数
  const findNodeByPath = (path, data) => {
    if (path.length === 0) return null;

    // 查找第一级节点
    const firstLevelNode = data.find((item) => item.id === path[0]);
    if (!firstLevelNode) return null;

    // 如果路径只有一级，返回该节点
    if (path.length === 1) return firstLevelNode;

    // 递归查找更深层级的节点
    let currentNode = firstLevelNode;
    for (let i = 1; i < path.length; i++) {
      if (!currentNode.children) return null;
      currentNode = currentNode.children.find((child) => child.id === path[i]);
      if (!currentNode) return null;
    }

    return currentNode;
  };

  selectedPaths.forEach((path) => {
    const node = findNodeByPath(path, dataSource);
    if (node) {
      collectLeafNodes(node);
    }
  });

  // 去重（基于 id）
  return leafNodes.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id));
};

export const reverseFormatPlayStyles = (playStyles, dataSource) => {
  // 需要找到对应的路径数组
  const paths = [];

  playStyles.forEach((style) => {
    // 在 tacticSeasonList 中查找这个 style
    for (const parent of dataSource) {
      if (parent.children) {
        const child = parent.children.find((child) => child.id === style.id);
        if (child) {
          paths.push([parent.id, child.id]);
          break;
        }
      }
      // 如果直接是父级节点
      if (parent.id === style.id) {
        paths.push([parent.id]);
        break;
      }
    }
  });

  return paths;
};

export const reverseFormatLabels = (labels, dataSource) => {
  // 需要找到对应的路径数组
  const paths = [];
  // 递归查找节点路径的函数
  const findNodePath = (nodeId, currentData, currentPath = []) => {
    for (const item of currentData) {
      const newPath = [...currentPath, item.id];
      if (item.id === nodeId) {
        return newPath;
      }
      if (item.children && item.children.length > 0) {
        const found = findNodePath(nodeId, item.children, newPath);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };
  labels.forEach((label) => {
    const path = findNodePath(label.id, dataSource);
    if (path) {
      paths.push(path);
    }
  });

  return paths;
};

const getChildren = (arr, targetArr) => {
  arr.forEach((item) => {
    if (item?.children && item.children.length > 0) {
      getChildren(item.children, targetArr);
    } else {
      targetArr.push(item);
    }
  });
};

export const formatTreeSelect = (value, targetArr) => {
  const expandedValues = [];
  const returnArr = [];

  getChildren(targetArr, expandedValues);

  value.forEach((item) => {
    const findItem = expandedValues.find((it) => it.id === item);
    if (findItem) {
      returnArr.push({ id: findItem.id, typeName: findItem.name });
    }
  });

  return returnArr;
};

export const reverseFormatTreeSelect = (value, targetArr) => {
  const expandedValues = [];
  const returnArr = [];

  getChildren(targetArr, expandedValues);

  expandedValues.forEach((item) => {
    const findItem = value.find((it) => it.id === item.id);
    if (findItem) {
      returnArr.push(Number(findItem.id));
    }
  });

  return returnArr;
};
